import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {EventType, InstructionEvent} from '../../../../../models/PartEvent';
import {v4} from 'uuid';

interface OwnProps {
    onSubmit: (partEvent: Omit<InstructionEvent, 'anchor'>) => void;
    onCancel: () => void;
}

export const InstructionStepComponent: FunctionComponent<OwnProps> = ({onSubmit, onCancel}) => {
    const [value, setValue] = useState<string>('');

    return (
        <>
            <div className="modal-header">
                <h2>Choose data field</h2>
            </div>
            <div className="modal-body">
                <div className="add-event-wizard">
                    <form>
                        <div className="form-group">
                            <label htmlFor="instruction">Instruction</label>
                            <input
                                id="instruction"
                                type="text"
                                name="instruction"
                                className="form-control"
                                value={value || ''}
                                onChange={(e) => setValue(e.target.value)}
                            />
                        </div>
                    </form>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-secondary pull-right"
                    onClick={() =>
                        onSubmit({
                            __uuid: v4(),
                            type: EventType.Instruction,
                            key: 'text',
                            value: value,
                        })
                    }
                >
                    Next
                </button>
                <button className="btn btn-secondary pull-right" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </>
    );
};
